module.exports = __webpack_public_path__ + "static/media/file-signature.31f67b8f.svg";